<template>
  <TableLayout :permissions="['business:refund:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="编码" prop="id">
        <el-input v-model="searchForm.id" placeholder="请输入编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="searchForm.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间" @change="search"/>
      </el-form-item>
      <el-form-item label="创建人" prop="creator">
        <el-input v-model="searchForm.creator" placeholder="请输入创建人" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="编辑时间" prop="editDate">
        <el-date-picker v-model="searchForm.editDate" value-format="yyyy-MM-dd" placeholder="请输入编辑时间" @change="search"/>
      </el-form-item>
      <el-form-item label="编辑人" prop="editor">
        <el-input v-model="searchForm.editor" placeholder="请输入编辑人" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="是否已删除 0未删除 1已删除" prop="isdeleted">
        <el-input v-model="searchForm.isdeleted" placeholder="请输入是否已删除 0未删除 1已删除" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="info">
        <el-input v-model="searchForm.info" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="退款编码" prop="code">
        <el-input v-model="searchForm.code" placeholder="请输入退款编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="用户编码（关联member表）" prop="memberId">
        <el-input v-model="searchForm.memberId" placeholder="请输入用户编码（关联member表）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="交易金额" prop="money">
        <el-input v-model="searchForm.money" placeholder="请输入交易金额" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="状态 0预退款 1退款失败 2退款完成" prop="status">
        <el-input v-model="searchForm.status" placeholder="请输入状态 0预退款 1退款失败 2退款完成" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="交易预订单号" prop="preOrderid">
        <el-input v-model="searchForm.preOrderid" placeholder="请输入交易预订单号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="在线交易单号" prop="onlineOrderid">
        <el-input v-model="searchForm.onlineOrderid" placeholder="请输入在线交易单号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="退款方式 0微信 1支付宝" prop="payWay">
        <el-input v-model="searchForm.payWay" placeholder="请输入退款方式 0微信 1支付宝" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="完成时间" prop="doneDate">
        <el-date-picker v-model="searchForm.doneDate" value-format="yyyy-MM-dd" placeholder="请输入完成时间" @change="search"/>
      </el-form-item>
      <el-form-item label="退款类型 0结算退款 1强制结算退款 2结算后退款" prop="type">
        <el-input v-model="searchForm.type" placeholder="请输入退款类型 0结算退款 1强制结算退款 2结算后退款" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="退款关联订单编码" prop="objId">
        <el-input v-model="searchForm.objId" placeholder="请输入退款关联订单编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="退款原因" prop="reason">
        <el-input v-model="searchForm.reason" placeholder="请输入退款原因" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:refund:create']">
        <li><el-button type="primary" @click="$refs.operaRefundWindow.open('新建退款信息表')" icon="el-icon-plus" v-permissions="['business:refund:create']">新建</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
      >
        <el-table-column prop="id" label="编码" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="creator" label="创建人" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="编辑时间" min-width="100px"></el-table-column>
        <el-table-column prop="editor" label="编辑人" min-width="100px"></el-table-column>
        <el-table-column prop="isdeleted" label="是否已删除 0未删除 1已删除" min-width="100px"></el-table-column>
        <el-table-column prop="info" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="code" label="退款编码" min-width="100px"></el-table-column>
        <el-table-column prop="memberId" label="用户编码（关联member表）" min-width="100px"></el-table-column>
        <el-table-column prop="money" label="交易金额" min-width="100px"></el-table-column>
        <el-table-column prop="status" label="状态 0预退款 1退款失败 2退款完成" min-width="100px"></el-table-column>
        <el-table-column prop="preOrderid" label="交易预订单号" min-width="100px"></el-table-column>
        <el-table-column prop="onlineOrderid" label="在线交易单号" min-width="100px"></el-table-column>
        <el-table-column prop="payWay" label="退款方式 0微信 1支付宝" min-width="100px"></el-table-column>
        <el-table-column prop="doneDate" label="完成时间" min-width="100px"></el-table-column>
        <el-table-column prop="type" label="退款类型 0结算退款 1强制结算退款 2结算后退款" min-width="100px"></el-table-column>
        <el-table-column prop="objId" label="退款关联订单编码" min-width="100px"></el-table-column>
        <el-table-column prop="reason" label="退款原因" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:refund:update', 'business:refund:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaRefundWindow.open('编辑退款信息表', row)" icon="el-icon-edit" v-permissions="['business:refund:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:refund:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaRefundWindow ref="operaRefundWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaRefundWindow from '@/components/business/OperaRefundWindow'
export default {
  name: 'Refund',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaRefundWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        createDate: '',
        creator: '',
        editDate: '',
        editor: '',
        isdeleted: '',
        info: '',
        code: '',
        memberId: '',
        money: '',
        status: '',
        preOrderid: '',
        onlineOrderid: '',
        payWay: '',
        doneDate: '',
        type: '',
        objId: '',
        reason: ''
      }
    }
  },
  created () {
    this.config({
      module: '退款信息表',
      api: '/business/refund',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
